import { createAsyncAtom } from '../lib';

const navigationPinAtom = createAsyncAtom(async () => {
  const storedValue = localStorage.getItem('navigationPin');

  if (storedValue === 'true') {
    return true;
  }

  return false;
});
export default navigationPinAtom;

function setNavigationPin(pinned: boolean) {
  navigationPinAtom.setValue(pinned);

  localStorage.setItem('navigationPin', pinned.toString());
}
export { setNavigationPin };
